<template>
    <!-- <div class="text-center h3 mt-4 mb-4" v-if="isLoading">
        Loading...
    </div>
    <div class="text-center" v-else-if="!isLoading && servermessages.length > 0">
        <ul class="messages alert alert-warning" v-if="servermessages.length > 0">
            <li v-for="message in servermessages" :key="message">
                {{ message }}    
            </li>                             
        </ul>
    </div> -->
    <base-spinner :open="isloading"></base-spinner>
    <base-message
    v-if="!isloading"
    :servermessages="servermessages"
    ></base-message>
    <div v-html="content" v-if="content != '' && !isloading"></div>
    <div class="text-center mt-4 mb-4" v-else-if="content === '' && !isloading">
        Content Unavailable.
    </div>
</template>

<script>
import axiosvl from "../../../axios/axios-vl.js";

export default {
    data() {
        return {
            content: '',
            isloading: false,
            error: '',
            servermessages: []
        }
    },
    methods: {
        getContent() {
            this.isloading = true;
            this.content = '';
            this.servermessages = [];
            const return_policy_uri = this.$store.getters['api/return_policy_uri'];
            // "/d15pgmlib/lansaweb?w=CESGETCNT&r=usGetSinglePageCont&vlweb=1&part=CML&lang=ENG&_T=20210114"
            axiosvl.post(return_policy_uri, {
                    "webroutine": {
                        "context": {
                            "session-key-method": "hidden"
                        },
                        "fields": {
                            LW3SFID: {
                                value: this.$store.getters.storefront,
                            },
                            "LW3PAGSDC": {
                                "value": 'RETCNCPOL'
                            },
                            "LW3PAGLSD": {
                                "value": 'MAIN'
                            }
                        }
                    }
                }
            )
            .then((response) => {
                this.isloading = false;

                const fields = response.data.webroutine.fields;
                this.content = fields.LW3CNTSTR.value;

                const messages = [];
                const wrmessages = response.data.webroutine.messages;

                if (wrmessages != undefined) {
                    for (var i = 0; i < wrmessages.length; i++) {
                        messages.push(wrmessages[i]);
                    }
                    this.servermessages = messages;
                }

            })
            .catch((error) => {
                this.isloading = false;
                this.servermessages.push('Something went wrong. Please try again later.');
                console.log("error - " + error);
            });
        }
    },
    created() {
        this.$ga.page({
            page: this.$route.fullPath,
            title: this.$route.name,
        });

        let tmout = 500;
        if (this.$store.getters.storefront == ''){
            tmout = 2000;
        }

        setTimeout(() => {
            this.getContent();
        }, tmout);
    }

}
</script>